import React, { useState, useEffect } from 'react'
import { Spinner } from 'reactstrap';
import { apiFactory } from 'services/ApiFactory';
import { checkNull, handleNullArray, isObjectNull } from 'utils/utils';
import { userType } from 'utils/constants';
import HubState from 'contexts/intranet/hub/HubState'

import { SecondLayout } from './SecondLayout/SecondLayout'

function Layout(props) {
        var manipulatedMenuChildren = [];
        const [accessAuthorization, setAccessAuthorization] = useState({
                drawerMenuItems: {},
                loading: true
        });

        useEffect(() => {
                var fakeData = props.fakeData;
                applyPermissions(fakeData.items);



        }, []);

        const getMenuChildren = (menuItems, permissions) =>{
                var manipulatedMenuChildren = [];

                menuItems.map((menuItem) => {
                        if (menuItem.children !== undefined) {
                                let resultItems = getMenuChildren(menuItem.children, permissions);

                                if (resultItems.length > 0) 
                                        manipulatedMenuChildren.push(resultItems);
                        } else {
                                if (menuItem.applicationComponentId !== undefined) {
                                        handleNullArray(permissions).map(permissionItem => {
                                                let localPermissionItem = permissionItem.role.permissions.find(cond => cond.applicationComponentId === menuItem.applicationComponentId);
                                                
                                                if (localPermissionItem !== undefined) {
                                                        var duplicate =
                                                        manipulatedMenuChildren.find(cond => cond.applicationComponentId === menuItem.applicationComponentId);
                                                        if (duplicate === undefined || duplicate == null) {
                                                                manipulatedMenuChildren.push(localPermissionItem);
                                                        }
                                                }

                                        });                                        
                                }
                        }
                });
                return manipulatedMenuChildren;
        }

        const rearrangePermissions = (userPermissions) => {
                if (userPermissions.applicationComponentId) {
                        manipulatedMenuChildren.push(userPermissions);
                } else {
                        for(let rep=0; rep < userPermissions.length; rep++) {
                                rearrangePermissions(userPermissions[rep]);
                        }        
                }
                return manipulatedMenuChildren;
        }

        const rearrangeUnpermittedMenuItems = (finalMenuItems, parentIem) => {
                        handleNullArray(finalMenuItems).map((finalMenuItem, finalMenuIndex) => {
                                if (finalMenuItem.children != undefined && finalMenuItem.children.length > 0 ) {
                                        rearrangeUnpermittedMenuItems(finalMenuItem.children, finalMenuItem);
                                } else {
                                        if (finalMenuItem.applicationComponentId == undefined){
                                                finalMenuItem.visible = false;
                                        }
                                        // finalMenuItemParent.
                                }
                        });        
                
                return finalMenuItems;
        }

        const   rearrangeParentVisibility = (menuItems, parent) => {
                handleNullArray(menuItems).map ((menuItem, menuIndex) => {
                        //if (menuItem.visible == false) {
                                //let localParent = parent
                                if (menuItem.visible == false ) {
                                        //if (localParent != null) {
                                                handleNullArray(menuItem.children).map((childItem, childIndex) => {
                                                        if (childItem.children !== undefined ) {
                                                                if (childItem.children.length == 0 && childItem.visible == false) {
                                                                        menuItem.children.splice(childIndex,1);
                                                                }
                                                        }
                                                })  
                                                if (menuItem.children !== undefined && menuItem.children.length == 0){
                                                        //menuItem.visible = false;
                                                        menuItems.splice(menuIndex,1);
                                                }
                                                rearrangeParentVisibility(menuItem.children, menuItem);
                                        //}
                                } else {
                                        //rearrangeParentVisibility(menuItem.children, menuItem);
                                }         
        
                        // } else {
                                // menuItems.splice(menuIndex,1);
                        //}
                })
                return menuItems;
        }

        const removeUnpermittedMenuItems = (userPermissions, menuItems) => {
                for(let rep = 0; rep < menuItems.length; rep++) {
                        let menuItem = menuItems[rep];
                        if ((menuItem.children !== undefined && menuItem.children.length > 0) || menuItem.applicationComponentId !== undefined) {
                        // if (menuItem.visible) {
                                if (!checkNull(menuItem.applicationComponentId) ) {
                                        var userPermittedItem = userPermissions.find(cond => cond.applicationComponentId == menuItem.applicationComponentId);
                                        
                                        if (checkNull(userPermittedItem)) {
                                                userPermittedItem = userPermissions.find(cond => cond.applicationComponent.parentId == menuItem.applicationComponentId);
                                        }

                                        if (userPermittedItem == undefined) {
                                                if (menuItem.applicationComponentId >= 0) {
                                                        menuItems.splice(rep, 1);
                                                        rep -=1;
                                                }
                                        }
                                } else {
                                        if (!checkNull(menuItem.children) && menuItem.children.length > 0){
                                                removeUnpermittedMenuItems(userPermissions,menuItem.children);
                                        }
                                }
                        } else {
                                menuItems.splice(rep, 1);
                                rep -=1;    
                        }
                }
                return menuItems;
        }

        // const addChildlessMenuItems = (menuItems) => {
        //         menuItems.map(menuItem => {
        //                 debugger;
        //                 if (!checkNull(menuItem)) {
        //                         if ((checkNull(menuItem.childItem) && menuItem.visible) || (menuItem.childItem.length === 0 && menuItem.visible)) {
        //                                 debugger;
        //                                 menuItems.push(menuItem);
        //                         } 
        //                 }
        //         });
        //         return menuItems;
        // }


        // const applyPermissions = (menuItems) => {

        //         var currentUser = {};
        //         var manipulatedMenuItems = [];
        //         var manipulatedMenuChildren = [];

        //         currentUser = apiFactory.intranetApiFactory.generalInformation.getPresentUserGeneralInfo();

        //         apiFactory.intranetApiFactory.authorization
        //                 .getUserFullAuthorization(currentUser.userId)
        //                 .then(result => {
        //                         var permissions = result.data.roleMembers;

        //                         handleNullArray(menuItems).map((item, index) => {
        //                                 if (item.children == undefined) {
        //                                         item.children = [];
        //                                         manipulatedMenuItems.push(item);
        //                                 } else {
        //                                         handleNullArray(item.children).map((menuChildren, menuChildrenIndex) => {
        //                                                 handleNullArray(permissions).map((permissionItem, permissionItemIndex) => {

        //                                                         handleNullArray(permissionItem.role.permissions).map((finalItem, finalItemIndex) => {
        //                                                                 if (menuChildren.applicationComponentId == finalItem.applicationComponentId) {
        //                                                                         var duplicate =
        //                                                                                 manipulatedMenuChildren.find(cond => cond.applicationComponentId == finalItem.applicationComponentId);

        //                                                                         if (duplicate == undefined || duplicate == null) {
        //                                                                                 manipulatedMenuChildren.push(menuChildren);
        //                                                                         }
        //                                                                 }
        //                                                         });
        //                                                 });
        //                                         });
        //                                         item.children = manipulatedMenuChildren;
        //                                         manipulatedMenuItems.push(item);
        //                                         manipulatedMenuChildren = [];
        //                                 }
        //                         })
        //                         if (manipulatedMenuItems.length > 0) {
        //                                 menuItems.items = manipulatedMenuItems;
        //                                 setAccessAuthorization({
        //                                         drawerMenuItems: menuItems.items,
        //                                         loading: false
        //                                 })
        //                         }

        //                 });



        //         props.fakeData.items = accessAuthorization.drawerMenuItems;
        // };        

        const applyPermissions = async (menuItems) => {
                manipulatedMenuChildren = [];

                let currentUser = {};
                let finalMenuItems = {};
                currentUser = apiFactory.intranetApiFactory.generalInformation.getPresentUserGeneralInfo();

                let isUserAdmin = (await apiFactory.intranetApiFactory.authorization.isUserSystemAdministrator(currentUser.userId)).data;
                let result = (await apiFactory.intranetApiFactory.authorization.getUserFullAuthorization(currentUser.userId)).data;

                if (!isUserAdmin){

                        let userPermissions = await getMenuChildren(menuItems, result.roleMembers);

                        userPermissions = await rearrangePermissions(userPermissions);

                        finalMenuItems = await removeUnpermittedMenuItems(userPermissions, menuItems);

                        finalMenuItems = await rearrangeUnpermittedMenuItems(finalMenuItems, null);

                        finalMenuItems = await rearrangeParentVisibility(finalMenuItems, null);        
                } 

                setAccessAuthorization(prev=>({
                        drawerMenuItems: !isUserAdmin ? finalMenuItems : menuItems,
                        loading: false
                }));

               
        };

        return (
                accessAuthorization.loading ? <React.Suspense fallback={<Spinner />} /> :
                        <HubState>
                                <SecondLayout {...props} />
                        </HubState>

        )

}

export default Layout;